import { motion } from "framer-motion";
import { APPLICATIONS } from "@/data";

export default function Applications() {
  return (
    <section
      data-testid="applications"
      id="applications"
      className="bg-background text-foreground py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16 border-t border-black/15 pt-6"
        >
          <span className="font-mono-accent text-xs uppercase tracking-[0.25em] text-primary">
            /03 — What we build
          </span>
          <h2 className="font-display mt-6 text-4xl md:text-6xl tracking-tighter max-w-4xl leading-[0.95]">
            From ground level to skyline.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-l border-t border-black/15">
          {APPLICATIONS.map((a, i) => (
            <motion.div
              key={a.n}
              data-testid={`application-${a.n}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="border-r border-b border-black/15 group"
            >
              <div className="relative overflow-hidden aspect-[4/5]">
                <img
                  src={a.img}
                  alt={a.title}
                  className="h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors" />
                <span className="absolute top-5 left-5 font-display text-5xl text-[#F5F4EF] mix-blend-difference">
                  {a.n}
                </span>
              </div>
              <div className="p-8">
                <h3 className="font-display text-2xl md:text-3xl tracking-tight mb-3">
                  {a.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">{a.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
